










































































































































import Vue from 'vue';
import _ from 'lodash';
import { formatObjectForBackend } from '@/core/api/utils/converter';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'CommunityGroupFormModal',
  computed: {
    ...mapGetters({
      allActiveTeacherProducts: 'product/allActiveTeacherProducts',
    }),
    formTitle() {
      if (this.group.id) {
        return this.$t('COMMUNITY.TITLE.EDIT_GROUP');
      } else {
        return this.$t('COMMUNITY.TITLE.ADD_GROUP');
      }
    },
    submitButtonLabel() {
      if (this.group.id) {
        return this.$t('COMMUNITY.BUTTON.SAVE');
      } else {
        return this.$t('COMMUNITY.BUTTON.ADD_NEW_GROUP');
      }
    },
    hashtags: {
      get() {
        return this.group?.hashtags || [];
      },
      set(hashtags) {
        console.log('setting hashtags', hashtags);
        this.$set(
          this.group,
          'hashtags',
          hashtags.map(e => this.toHashtag(e))
        );
        console.log('group.hashtags=', this.group.hashtags);
        console.log('this.hashtags=', this.hashtags);
      },
    },
  },
  props: {
    group: {
      type: Object as () => CommunityGroupsResponse,
      default: {},
    },
    confirm: null,
  },
  data() {
    return {
      isLoading: false,
      groupProductsId: [],
      groupCoverPhotosId: null,
      groupThumbnailPhotosId: null,
    };
  },
  methods: {
    toHashtag(s) {
      return `#${s.trim().replace(/[^0-9a-z]/gi, '')}`;
    },
    async onConfirm() {
      await this.$emit('close');
      this.group.cover_photo = this.groupCoverPhotosId;
      this.group.thumbnail_photo = this.groupThumbnailPhotosId;
      this.group.products = this.groupProductsId;
      await this.confirm(this.group);
    },
    async onDiscard() {
      if (this.discard) {
        await this.discard();
      }
      await this.$emit('close');
    },
    loadProducts() {
      this.$store.dispatch('product/getTeacherProducts');
    },
  },
  async mounted() {
    this.loadProducts();
  },
  watch: {
    'group.cover_photo': {
      handler(value) {
        this.groupCoverPhotosId = value;
      },
      immediate: true,
    },
    'group.thumbnail_photo': {
      handler(value) {
        this.groupThumbnailPhotosId = value;
      },
      immediate: true,
    },
    'group.products': {
      handler(value) {
        this.groupProductsId = value;
      },
      immediate: true,
    },
  },
});
